import { supabase } from './supabase';

export const testCreatePaymentIntent = async () => {
  try {
    console.log('🧪 Testing create-payment-intent function...');
    
    // Check if user is authenticated
    const { data: { user }, error: userError } = await supabase.auth.getUser();
    if (userError || !user) {
      console.error('❌ User not authenticated:', userError);
      return { success: false, error: 'User not authenticated' };
    }
    
    console.log('✅ User authenticated:', user.id);

    // Get session
    const { data: { session }, error: sessionError } = await supabase.auth.getSession();
    if (sessionError || !session) {
      console.error('❌ No active session:', sessionError);
      return { success: false, error: 'No active session' };
    }
    
    console.log('✅ Session found');

    // Call create-payment-intent function with exact same parameters as stripeService
    console.log('🚀 Calling create-payment-intent function...');
    
    try {
      const response = await fetch(`${import.meta.env.VITE_SUPABASE_URL}/functions/v1/create-payment-intent`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${session.access_token}`,
          'apikey': import.meta.env.VITE_SUPABASE_ANON_KEY,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          plan: 'premium',
          priceId: 'price_1RmFnwGG5dpuxsMKYJREqXTU',
          trialDays: 7
        })
      });

      console.log('📊 Response status:', response.status);
      console.log('📊 Response headers:', Object.fromEntries(response.headers.entries()));

      const responseText = await response.text();
      console.log('📊 Raw response:', responseText);

      let data;
      try {
        data = JSON.parse(responseText);
        console.log('📊 Parsed response:', data);
      } catch (parseError) {
        console.error('❌ Failed to parse response as JSON:', parseError);
        return { success: false, error: 'Invalid JSON response', rawResponse: responseText };
      }

      if (!response.ok) {
        console.error('❌ Create payment intent error - Status:', response.status);
        console.error('❌ Error response:', data);
        return { success: false, error: data.error || 'Unknown error', details: data, status: response.status };
      }

      console.log('✅ Create payment intent response:', data);
      return { success: true, data };

    } catch (fetchError) {
      console.error('❌ Fetch error:', fetchError);
      return { success: false, error: fetchError.message, details: fetchError };
    }

    console.log('✅ Create payment intent response:', data);
    return { success: true, data };

  } catch (error) {
    console.error('❌ Test create payment intent error:', error);
    return { success: false, error: error.message };
  }
};

// Make test function globally available
if (typeof window !== 'undefined') {
  window.testCreatePaymentIntent = testCreatePaymentIntent;
  console.log('🔧 Test create payment intent function loaded - run testCreatePaymentIntent() in console');
}

console.log('🚀 testCreatePayment.js module loaded successfully');
